/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Issue_Title_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Issue title..." |
*
* @param {Manual_Qc_Issue_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_issue_title_placeholder = /** @type {((inputs?: Manual_Qc_Issue_Title_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Issue_Title_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre de l'incident...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Titel der Ausgabe...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Titolo del problema...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название выпуска...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Título del número...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问题标题……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題のタイトル...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंक का शीर्षक...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Título da edição...")
	return /** @type {LocalizedString} */ ("Issue title...")
});